import { darken, Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { BankIcon, FamilyIcon, HouseIcon } from "../../../../assets/icons";
import { EmployeePersonalDataSummaryDTO } from "../../../../models/employee-personal-data-summary/employee-personal-data-summary-dto";
import IconAndTitleContainer from "../../reusable-widget-link-components/IconAndTitleContainer/IconAndTitleContainer";

interface State {
  error: string;
  loading: boolean;
  summary: EmployeePersonalDataSummaryDTO | null;
}

interface Props {
  customSummary: EmployeePersonalDataSummaryDTO;
  loading: boolean;
}

const MyDataWidgetComponent = ({ customSummary, loading }: Props) => {
  const { t } = useTranslation();
  const tRP = "components.custom_widget_components.my_data";
  const theme = useTheme();
  //   const [state, setState] = useState<State>({
  //     error: "",
  //     loading: false,
  //     summary: null,
  //   });
  //   const loadSummary = useCallback(async (signal: AbortSignal) => {
  //     setState((state) => ({
  //       ...state,
  //       loading: true,
  //     }));
  //     try {
  //       const response = await new EmployeePersonalDataSummaryApiService().loadItems(
  //         {},
  //         undefined,
  //         undefined,
  //         undefined,
  //         undefined,
  //         60,
  //         signal,
  //         undefined
  //       );
  //       if (!response.error) {
  //         setState((state) => ({
  //           ...state,
  //           summary: response.items[0],
  //         }));
  //       } else {
  //         setState((state) => ({
  //           ...state,
  //           error: response.error,
  //         }));
  //       }
  //     } catch (error) {
  //       setState((state) => ({
  //         ...state,
  //         error: error as string,
  //       }));
  //     } finally {
  //       setState((state) => ({
  //         ...state,
  //         loading: false,
  //       }));
  //     }
  //   }, []);

  //   useEffect(() => {
  //     const abortController = new AbortController();

  //     loadSummary(abortController.signal);

  //     return () => {
  //       abortController.abort();
  //     };
  //   }, []);

  return (
    <Grid
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        padding: "10px",
        justifyContent: "space-evenly",
        height: "60%",
        cursor: "pointer",
      }}
    >
      <IconAndTitleContainer
        title={
          customSummary?.address
            ? `${customSummary?.address.substring(0, 20)} ${
                customSummary?.address.length ? (customSummary?.address.length > 10 ? "..." : "") : ""
              }`
            : `${t(`${tRP}.no_address`)}`
        }
        titleStyle={{ color: darken(theme.palette.text.secondary, 0.15) }}
        Icon={HouseIcon}
        loading={loading}
      />
      <IconAndTitleContainer
        title={`${customSummary?.bankAccountName ? customSummary?.bankAccountName : t(`${tRP}.no_bic`)} 
        ${
          customSummary?.bankAccountIBAN
            ? `...${customSummary?.bankAccountIBAN.substring(customSummary?.bankAccountIBAN.length - 4)}`
            : `/${t(`${tRP}.no_iban`)}`
        } `}
        titleStyle={{ color: darken(theme.palette.text.secondary, 0.15) }}
        Icon={BankIcon}
        loading={loading}
      />
      <IconAndTitleContainer
        title={customSummary?.dependents?.length ? customSummary?.dependents.join(", ") : t(`${tRP}.no_dependents`)}
        titleStyle={{ color: darken(theme.palette.text.secondary, 0.15) }}
        Icon={FamilyIcon}
        loading={loading}
      />
    </Grid>
  );
};
export default MyDataWidgetComponent;
